import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "../config";

/**
 * ─── AuthContext (with roles) ───
 *
 * Stores: user (username), role ("admin" or "member"), email
 * On page load → calls /api/auth/user to check if cookie is valid
 * If valid → sets user info. If not → user stays null (guest).
 */

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // username
  const [role, setRole] = useState(null);     // "admin" or "member"
  const [email, setEmail] = useState(null);   // member's email
  const [name, setName] = useState(null);     // full name
  const [sex, setSex] = useState(null);       // kjønn
  const [age, setAge] = useState(null);       // alder
  const [phone, setPhone] = useState(null);   // telefon
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/auth/user`, {
      credentials: "include",
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data) {
          setUser(data.username);
          setRole(data.role);
          setEmail(data.email);
          setName(data.name);
          setSex(data.sex);
          setAge(data.age);
          setPhone(data.phone);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const login = (username, userRole, userEmail, userName, userSex, userAge, userPhone) => {
    setUser(username);
    setRole(userRole);
    setEmail(userEmail);
    setName(userName);
    setSex(userSex);
    setAge(userAge);
    setPhone(userPhone);
  };

  const logout = async () => {
    await fetch(`${API_URL}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    setUser(null);
    setRole(null);
    setEmail(null);
    setName(null);
    setSex(null);
    setAge(null);
    setPhone(null);
  };

  return (
    <AuthContext.Provider value={{ user, role, email, name, sex, age, phone, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
